import React from 'react';
import './Logo.scss';
import logo from '../../assets/logo.png';
import { motion } from 'framer-motion';

const SplashScreen = () => {
  return (
    <motion.div
      className="splash-container"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <motion.img
        src={logo}
        alt="logo"
        className="splash-logo"
        initial={{ scale: 0.5, rotate: 0, opacity: 0 }}
        animate={{
          scale: [0.5, 1.4, 1],
          rotate: [0, 0, 0],
          opacity: [0, 1],
        }}
        transition={{
          duration: 2,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="glow-pulse"
        initial={{ scale: 1, opacity: 0.4 }}
        animate={{
          scale: [1, 1.6, 1],
          opacity: [0.4, 0.8, 0.4],
        }}
        transition={{
          repeat: Infinity,
          duration: 2.5,
          ease: 'easeInOut',
        }}
      />
    </motion.div>
  );
};

export default SplashScreen;
